import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "course_and_broadcast_container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item_img_wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "item_img_tag"
}
const _hoisted_6 = { class: "tag_text" }
const _hoisted_7 = { class: "item_img_type" }
const _hoisted_8 = { class: "type_text" }
const _hoisted_9 = { class: "item_text" }
const _hoisted_10 = { class: "item_detail" }
const _hoisted_11 = { class: "detail_score" }
const _hoisted_12 = { class: "detail_count" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "item_img_wrapper" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "item_text" }
const _hoisted_17 = { class: "item_text2" }
const _hoisted_18 = { class: "item_label" }
const _hoisted_19 = { class: "detail_time" }
const _hoisted_20 = { class: "detail_num" }
const _hoisted_21 = {
  key: 1,
  class: "list1"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "item_img_wrapper" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 0,
  class: "item_img_tag"
}
const _hoisted_26 = { class: "tag_text" }
const _hoisted_27 = { class: "item_img_type" }
const _hoisted_28 = { class: "type_text" }
const _hoisted_29 = { class: "item_text_wrapper" }
const _hoisted_30 = { class: "item_text" }
const _hoisted_31 = { class: "item_detail item_detail1" }
const _hoisted_32 = { class: "detail_score" }
const _hoisted_33 = { class: "item_detail item_detail1" }
const _hoisted_34 = { class: "detail_count" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "item_img_wrapper" }
const _hoisted_37 = ["src"]
const _hoisted_38 = { class: "item_text_wrapper" }
const _hoisted_39 = { class: "item_text" }
const _hoisted_40 = { class: "item_author" }
const _hoisted_41 = { class: "item_label" }
const _hoisted_42 = { class: "detail_time" }
const _hoisted_43 = { class: "detail_num" }

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import CardTitle from './CardTitle.vue'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useThemeColor } from '@/utils/theme'
import { useRouter } from 'vue-router'
import { addViewCountReq, addUvCountReq } from '@/api/requests/BroadRequests'

interface TItem {
  fileId: string
  fileType: number
}
interface TItem1 {
  id: string
  articleType: number
  jumpUrl: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'BroadcastAndCourse',
  props: {
    data: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v659cd184": (_unref(themeColor))
}))

const props = __props

const router = useRouter()
const skipCourseHandle = (item: TItem) => {
  router.push({
    name: 'courseDetail',
    query: {
      id: item.fileId,
      courseId: '',
      endingType: 0,
      channel: 0,
      courseType: item.fileType > 0 ? 'courseWare' : 'course'
    }
  })
}
const skipBroadcastHandle = async (item: TItem1) => {
  addUvCountReq({
    id: item.id
  })
  if (item.articleType === 1 && item.jumpUrl && item.jumpUrl.length > 0) {
    try {
      const res = await addViewCountReq({ id: item.id })
      if (res?.code === 1) {
        window.location.href = item.jumpUrl
      }
    } catch (error) {
      console.error('Error adding view count:', error)
    }
  } else {
    router.push('/broadcastDetail/' + item.id)
  }
}

const broadcastData = computed(() => {
  const datas = props.data.lmsDecorateModuleCategories[0].datas
  if (!datas) {
    return []
  }
  let json = ''
  for (let i = 0; i < datas.length; i++) {
    const item = datas[i]
    if (item.type === 4) {
      json = item.json
    }
  }
  try {
    // console.log(JSON.parse(json))
    return JSON.parse(json)
  } catch (error) {
    return []
  }
})
const courseData = computed(() => {
  const datas = props.data.lmsDecorateModuleCategories[0].datas
  if (!datas) {
    return []
  }
  let json = ''
  for (let i = 0; i < datas.length; i++) {
    const item = datas[i]
    if (item.type === 3) {
      json = item.json
    }
  }
  try {
    // console.log(JSON.parse(json))
    return JSON.parse(json)
  } catch (error) {
    return []
  }
})
const listData = computed(() => {
  const arr = [...courseData.value, ...broadcastData.value].sort((a, b) => {
    return a.sort - b.sort
  })
  return arr
})

const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).layoutType
  } catch (error) {
    return 3
  }
})
const isSmallList = computed(() => type.value === 1)
const isBigList = computed(() => type.value === 2)
const isGridList = computed(() => type.value === 3)

const { t } = useI18n()
const getFileTypeName = (type: number) => {
  // 类型 0:课程,1:文档,2:视频,3:图片
  switch (type) {
    case 0:
      return t('app_course')
    case 1:
      return t('tag_doc')
    case 2:
      return t('tag_video')
    case 3:
      return t('tag_pic')
  }
}

const themeColor = useThemeColor()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CardTitle, {
      title: __props.data.title,
      skipPage: '/broadcastAndCourse?moduleId=' + __props.data.id
    }, null, 8, ["title", "skipPage"]),
    (isBigList.value || isGridList.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["list", { full: isBigList.value }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (item.fileId)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "list_item",
                    onClick: ($event: any) => (skipCourseHandle(item))
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("img", {
                        class: "item_img",
                        src: item.coverImgUrl
                      }, null, 8, _hoisted_4),
                      (item.learnStatus === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('app_learned_short')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(getFileTypeName(item.fileType)), 1)
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(item.fileName), 1),
                    _createElementVNode("p", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(item.score || 0) + _toDisplayString(_ctx.$t('app_score')), 1),
                      _createElementVNode("span", _hoisted_12, " | " + _toDisplayString(item.learnNum) + _toDisplayString(_ctx.$t('app_people_learned')), 1)
                    ])
                  ], 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "list_item",
                    onClick: ($event: any) => (skipBroadcastHandle(item))
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        class: "item_img",
                        src: item.coverImgUrl
                      }, null, 8, _hoisted_15)
                    ]),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(item.title), 1),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(item.author), 1),
                    _createElementVNode("p", _hoisted_18, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(item.releaseTime), 1),
                      _createElementVNode("span", _hoisted_20, [
                        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "iconfont icon-icon_shouye_guankanrenshu" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(item.viewCount), 1)
                      ])
                    ])
                  ], 8, _hoisted_13))
            ], 64))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    (isSmallList.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listData.value, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.id
            }, [
              (item.fileId)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "list_item",
                    onClick: ($event: any) => (skipCourseHandle(item))
                  }, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("img", {
                        class: "item_img",
                        src: item.coverImgUrl
                      }, null, 8, _hoisted_24),
                      (item.learnStatus === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t('app_learned_short')), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(getFileTypeName(item.fileType)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("p", _hoisted_30, _toDisplayString(item.fileName), 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(item.score || 0) + _toDisplayString(_ctx.$t('app_score')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(item.learnNum) + _toDisplayString(_ctx.$t('app_people_learned')), 1)
                      ])
                    ])
                  ], 8, _hoisted_22))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "list_item",
                    onClick: ($event: any) => (skipBroadcastHandle(item))
                  }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("img", {
                        class: "item_img",
                        src: item.coverImgUrl
                      }, null, 8, _hoisted_37)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("p", _hoisted_39, _toDisplayString(item.title), 1),
                      _createElementVNode("p", _hoisted_40, _toDisplayString(item.author), 1),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(item.releaseTime), 1),
                        _createElementVNode("span", _hoisted_43, [
                          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "iconfont icon-icon_shouye_guankanrenshu" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(item.viewCount), 1)
                        ])
                      ])
                    ])
                  ], 8, _hoisted_35))
            ], 64))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})